import { Injectable, NgZone } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import CryptoJS from 'crypto-js';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';
import { DecodedToken } from '../models/user-right';

@Injectable({ providedIn: 'root' })
export class PosthogService {
    constructor(
        private _jwtHelper: JwtHelperService,
        private ngZone: NgZone,
    ) {
        if(environment.envName === 'prod') {
            this.initPostHog();
        }
    }

    private initPostHog() {
        console.log('Initializing PostHog');
        this.ngZone.runOutsideAngular(() => {
            posthog.init(environment.posthogKey, {
                api_host: environment.posthogHost,
                defaults: '2026-01-30',
                persistence: 'localStorage',
                person_profiles: 'identified_only',
            });
            
            const decodedToken = <DecodedToken>this._jwtHelper.decodeToken(localStorage.getItem('token'));
            const emailHash = CryptoJS.SHA256(decodedToken?.email);
            const namelHash = CryptoJS.SHA256(decodedToken?.name);
            
            posthog.identify(
                emailHash.toString(),
                {
                    emailHash: emailHash.toString(),
                    name: namelHash.toString(),
                },
            );
        });
    }
}